export { default as Legend } from './base';
export { Size, Color } from './continuous';
export { CanvasCategory, HtmlCategory } from './category';
//# sourceMappingURL=index.js.map